import http from "../../http-common";

const searchNF = (data) => http.post("/SeparacaoMateriais/getInformacoesNota", data);

const saveClientDelivery = (data) => http.post("/SeparacaoMateriais/InsertEntregaCliente", data);

const saveVolume = (data) => http.post("/SeparacaoMateriais/insertVolume", data);

const leituraEan = (data) => http.post("/SeparacaoMateriais/leituraEan", data);

const handleGetGrid = (data) => http.post("/SeparacaoMateriais/getGridItensFaltantes", data);

const getListaPorVolume = (data) => http.post("/SeparacaoMateriais/getListaPorVolume", data);

const deleteLeitura = (data) => http.post("/SeparacaoMateriais/deleteLeitura", data);

const finalizarEntrega = (data) => http.post("/SeparacaoMateriais/finalizarEntrega", data);

const qtdRequerida = (data) => http.post("/SeparacaoMateriais/qtdRequerida", data);

const qtdLida = (data) => http.post("/SeparacaoMateriais/qtdLida", data);

const searchVolumes = (data) => http.post("/SeparacaoMateriais/getVolumesState", data);

const deletarVolume = (data) => http.post("/SeparacaoMateriais/deletarVolume", data);

export default { searchNF, saveClientDelivery, saveVolume, leituraEan, handleGetGrid, getListaPorVolume, deleteLeitura, finalizarEntrega, qtdRequerida, qtdLida, searchVolumes, deletarVolume };
